<template>
    <span
        v-bind:class="classObj"
        class="d-inline-block"
        v-bind:title="title" />
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/pcComponentDefaults.i18n";

    export default {
        props: {
            exposed: { type: Boolean, required: false, default: false },
            attachment: { type: Boolean, required: false, default: false }
        },
        computed: {
            classObj() {
                return {
                    "sensitive-data-icon-obfuscated": !this.exposed,
                    "sensitive-data-icon": this.exposed
                };
            },
            title() {
                return this.attachment ? this.pcSensitiveIconTitleIsAttachment : this.pcSensitiveIconTitleIsField;
            },
            ...mapI18n(
                {
                    [KEYS.pcSensitiveIconTitleIsAttachment]: KEYS.pcSensitiveIconTitleIsAttachment,
                    [KEYS.pcSensitiveIconTitleIsField]: KEYS.pcSensitiveIconTitleIsField
                },
                NAMESPACE
            )
        }
    };
</script>
<style lang="scss" scoped>
    %sensitive-data-shared {
        padding-left: 5px;
        width: 16px;
        height: 16px;
        min-width: 16px;
        min-height: 16px;
        background-repeat: no-repeat;
        background-position: center;
        vertical-align: bottom;
    }

    .sensitive-data-icon-obfuscated {
        @extend %sensitive-data-shared;
        background-image: url("Images/icons/shield_fill.png");
    }

    .sensitive-data-icon {
        @extend %sensitive-data-shared;
        background-image: url("Images/icons/shield_empty.png");
    }
</style>
